"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePropsResolver = void 0;
var dealer_common_1 = require("@wix/dealer-common");
var ImagePropsResolver = /** @class */ (function () {
    function ImagePropsResolver(props) {
        this.context = props.context;
        this.hover = props.hover;
        this.CmsElement = props.element;
    }
    ImagePropsResolver.prototype.resolve = function () {
        var hoverSrc = dealer_common_1.extractParam(this.CmsElement, this.context, 'hoverSrc');
        var noHoverSrc = dealer_common_1.extractParam(this.CmsElement, this.context, 'src');
        var imgMetadata = this.resolveImageSrc(this.hover && hoverSrc ? hoverSrc : noHoverSrc);
        return this.resolveImgProps(imgMetadata.source, imgMetadata.url);
    };
    ImagePropsResolver.prototype.resolveImageSrc = function (src) {
        if (this.isFullURLImage(src)) {
            return { source: 2 /* External */, url: src };
        }
        if (this.isCmsMediaPlatformImage(src)) {
            return {
                source: 1 /* CMSMediaPlatform */,
                url: "//wixmp-2c8f906a62709a387faa1da5.wixmp.com" + src
            };
        }
        return {
            source: 0 /* Legacy */,
            url: "//static.wixstatic.com" + src
        };
    };
    ImagePropsResolver.prototype.isCmsMediaPlatformImage = function (src) {
        return src && src.startsWith('/banner-images/');
    };
    ImagePropsResolver.prototype.isValidURL = function (url) {
        var res = url.match(/^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        return !!res && res.length > 0;
    };
    ImagePropsResolver.prototype.isFullURLImage = function (src) {
        return src && this.isValidURL(src);
    };
    ImagePropsResolver.prototype.resolveImgProps = function (source, url) {
        /*
         An image from legacy / media platform source render img without width and height <img src={src} />
         because image size has already been adjusted.
         An image from an external source can be any size so we need to adjust and shrink it
         We're not passing width and height to image from legacy / media platform in order to not break an existing behavior.
       */
        if (source === 2 /* External */) {
            var height = dealer_common_1.extractParam(this.CmsElement, this.context, 'height');
            var width = dealer_common_1.extractParam(this.CmsElement, this.context, 'width');
            return {
                src: url,
                width: width,
                height: height
            };
        }
        return { src: url };
    };
    return ImagePropsResolver;
}());
exports.ImagePropsResolver = ImagePropsResolver;
//# sourceMappingURL=ImagePropsResolver.js.map